function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Comparable from '../../../../../java/lang/Comparable';
var SweepLineEvent = /*#__PURE__*/function () {
  function SweepLineEvent() {
    _classCallCheck(this, SweepLineEvent);
    SweepLineEvent.constructor_.apply(this, arguments);
  }
  return _createClass(SweepLineEvent, [{
    key: "isDelete",
    value: function isDelete() {
      return this._eventType === SweepLineEvent.DELETE;
    }
  }, {
    key: "setDeleteEventIndex",
    value: function setDeleteEventIndex(deleteEventIndex) {
      this._deleteEventIndex = deleteEventIndex;
    }
  }, {
    key: "getObject",
    value: function getObject() {
      return this._obj;
    }
  }, {
    key: "compareTo",
    value: function compareTo(o) {
      var pe = o;
      if (this._xValue < pe._xValue) return -1;
      if (this._xValue > pe._xValue) return 1;
      if (this._eventType < pe._eventType) return -1;
      if (this._eventType > pe._eventType) return 1;
      return 0;
    }
  }, {
    key: "getInsertEvent",
    value: function getInsertEvent() {
      return this._insertEvent;
    }
  }, {
    key: "isInsert",
    value: function isInsert() {
      return this._eventType === SweepLineEvent.INSERT;
    }
  }, {
    key: "isSameLabel",
    value: function isSameLabel(ev) {
      if (this._label === null) return false;
      return this._label === ev._label;
    }
  }, {
    key: "getDeleteEventIndex",
    value: function getDeleteEventIndex() {
      return this._deleteEventIndex;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return SweepLineEvent;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Comparable];
    }
  }]);
}();
export { SweepLineEvent as default };
SweepLineEvent.constructor_ = function () {
  this._label = null;
  this._xValue = null;
  this._eventType = null;
  this._insertEvent = null;
  this._deleteEventIndex = null;
  this._obj = null;
  if (arguments.length === 2) {
    var x = arguments[0];
    var insertEvent = arguments[1];
    this._eventType = SweepLineEvent.DELETE;
    this._xValue = x;
    this._insertEvent = insertEvent;
  } else if (arguments.length === 3) {
    var label = arguments[0];
    var _x = arguments[1];
    var obj = arguments[2];
    this._eventType = SweepLineEvent.INSERT;
    this._label = label;
    this._xValue = _x;
    this._obj = obj;
  }
};
SweepLineEvent.INSERT = 1;
SweepLineEvent.DELETE = 2;